import { API, METHODS } from "../../../shared/constants";
import { request } from "../../../shared/utils";
import { IRoomUpdateData } from "../interfaces";

export default {
  updateRoom: (id: number, data: IRoomUpdateData) => request(METHODS.PUT, API.UPDATE_ROOM(id))(data),
};
